import React from 'react';

const QuestionNavigation = ({ 
  currentQuestion, 
  currentQuestionIndex,
  handlePrevious,
  handleNext,
  toggleMarkForReview,
  handleAnswerChange,
  setShowSubmitConfirm,
  questions
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-8 pt-6 border-t border-gray-200">
      <button
        onClick={() => {
          toggleMarkForReview(currentQuestionIndex);
          if (currentQuestionIndex < questions.length - 1) {
            handleNext();
          }
        }}
        className="px-4 py-3 bg-purple-600 text-white rounded-lg font-semibold hover:bg-purple-700 transition shadow-md"
      >
        Mark & Next
      </button>
      
      <button
        onClick={() => handleAnswerChange(currentQuestion.id, '')}
        className="px-4 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition"
      >
        Clear Response
      </button>

      <button
        onClick={handlePrevious}
        disabled={currentQuestionIndex === 0}
        className="px-4 py-3 bg-white border-2 border-indigo-600 text-indigo-600 rounded-lg font-semibold hover:bg-indigo-50 transition disabled:opacity-30 disabled:cursor-not-allowed"
      >
        ← Previous
      </button>

      {currentQuestionIndex < questions.length - 1 ? (
        <button
          onClick={handleNext}
          className="px-4 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition shadow-md"
        >
          Save & Next →
        </button>
      ) : (
        <button
          onClick={() => setShowSubmitConfirm(true)}
          className="px-4 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition shadow-md"
        >
          Submit Exam
        </button>
      )}
    </div>
  );
};

export default QuestionNavigation;
